import * as React from 'react'
import {
  cloneElement
} from 'react'
import {
  sanitizeListRestProps,
  // ExportButton,
  // Filter,
  TopToolbar, useListContext
} from 'react-admin'


type TeamMemberListActionsType = {
  className?: string;
  filters?: any;
  accountId?: string;
}

export const TeamMemberListActions: React.FC<TeamMemberListActionsType> = (props) => {
  const {
    className,
    // exporter,
    filters,
    // maxResults,
    accountId,
    ...rest
  } = props
  const {
    // currentSort,
    resource,
    displayedFilters,
    filterValues,
    // hasCreate,
    // basePath,
    // selectedIds,
    showFilter,
    // total,
  } = useListContext()
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      {/* <CreateButton basePath={basePath} />
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filterValues={filterValues}
        maxResults={maxResults}
      /> */}
      {/* Add your custom actions */}
      {/* <Button
        onClick={() => {
          alert('Your custom action');
        }}
        label="Invite"
      >
        <AddIcon />
      </Button> */}
      {/* <TeamInviteButton accountId={accountId} /> */}
    </TopToolbar>
  )
}
